import { Component, Inject, OnInit, ViewChild,EventEmitter } from '@angular/core';
import { DirectionType, HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_309';
const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;
declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: '', listHelp: ['232'] }, // 1.Indique el valor total de ingresos que aparece en su Certificado de Ingresos y Retenciones (Formulario 220)
  { text: "2", active: false, completed: false, tooltip: '', listHelp: ['233'] },//3. ¿Usted retiró ahorros de cuentas AFC, FVP o AVC, sin el cumplimiento de requisitos de ley (permanencia y destinación) cuyos aportes fueron originados de rentas de trabajo?
  { text: "3", active: false, completed: false, tooltip: '', listHelp: ['235'] },//¿Usted retiró ahorros de cuentas AFC, FVP o AVC, sin el cumplimiento de requisitos de ley (permanencia y destinación) cuyos aportes fueron originados de rentas de trabajo?
  { text: "4", active: false, completed: false, tooltip: '', listHelp: ['236'] },//Indique el valor de sus aportes obligatorios a salud
  { text: "5", active: false, completed: false, tooltip: '', listHelp: ['237'] },//Indique el valor de sus aportes obligatorios a fondos de pensiones y solidaridad pensional
  { text: "6", active: false, completed: false, tooltip: '', listHelp: ['238'] },//Indique el valor total de su cotización voluntaria al Régimen de Ahorro Individual con Solidaridad (RAIS) durante
  { text: "7", active: false, completed: false, tooltip: '', listHelp: ['239'] },// Si usted es funcionario o empleado público y su empleador le dio apoyos económicos para programas de educación, indique el valor
  { text: "8", active: false, completed: false, tooltip: '', listHelp: ['241'] },//10.Consulte el certificado entregado por su fondo de cesantias
                                                                               //11. Indique el promedio de su salario en los 6 meses anteriores a la fecha del retiro de las cesantías                    
  { text: "9", active: false, completed: false, tooltip: '', listHelp: ['243'] },//12. Si a usted le consignaron cesantías en su fondo o recibió pagos por cesantías e intereses de cesantías, indique el valor total de las consignaciones y pagos
                                                                               //13. Indique el promedio de su salario en los 6 meses anteriores a la fecha en que recibió esas consignaciones o pagos             
  { text: "10", active: false, completed: false, tooltip: '', listHelp: ['246'] },
  { text: "11", active: false, completed: false, tooltip: '', listHelp: ['249'] },
  { text: "12", active: false, completed: false, tooltip: '', listHelp: ['250'] },
  { text: "13", active: false, completed: false, tooltip: '', listHelp: ['251'] },
  { text: "14", active: false, completed: false, tooltip: '', listHelp: ['252'] },
  { text: "15", active: false, completed: false, tooltip: '', listHelp: ['253'] },
  { text: "16", active: false, completed: false, tooltip: '', listHelp: ['254'] },
  { text: "17", active: false, completed: false, tooltip: '', listHelp: ['255'] },
  { text: "18", active: false, completed: false, tooltip: '', listHelp: ['267'] },
  { text: "19", active: false, completed: false, tooltip: '', listHelp: ['274'] },
  { text: "20", active: false, completed: false, tooltip: '', listHelp: ['258'] },
  { text: "21", active: false, completed: false, tooltip: '', listHelp: ['260'] },
  { text: "22", active: false, completed: false, tooltip: '', listHelp: ['329'] },
  { text: "23", active: false, completed: false, tooltip: '', listHelp: ['329'] },
  { text: "24", active: false, completed: false, tooltip: '', listHelp: ['268'] },
  { text: "25", active: false, completed: false, tooltip: '', listHelp: ['271'] },
  { text: "26", active: false, completed: false, tooltip: '', listHelp: ['272'] }
];

@Component({
  selector: 'app-renta-laboral-asalariado-modal',
  templateUrl: './renta-laboral-asalariado-modal.component.html',
  styleUrls: ['./renta-laboral-asalariado-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DBasicosParametricasServicios, 
    DValorPeriodico, 
    DValorDominio 
  ]
})
export class RentasLaboralAsalariadoModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  public UVT:string='';
  

  tiposDocumentofiltrado: DValorDominio[] = [];
  tiposParentesco: DValorDominio[] = [];

  constructor(
    public dialogRef: MatDialogRef<RentasLaboralAsalariadoModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
    this.obtenerValorPeriodico110();
  }


  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cs_id_232 == undefined) this.model.doc.cuerpo.cs_id_232 = "0"; 
    if (this.model.doc.cuerpo.cs_id_233 == undefined) this.model.doc.cuerpo.cs_id_233 = "0";
    if (this.model.doc.cuerpo.cs_id_234 == undefined) this.model.doc.cuerpo.cs_id_234 = null;
    if (this.model.doc.cuerpo.cs_id_235 == undefined) this.model.doc.cuerpo.cs_id_235 = "0";
    if (this.model.doc.cuerpo.cs_id_236 == undefined) this.model.doc.cuerpo.cs_id_236 = "0";
    if (this.model.doc.cuerpo.cs_id_237 == undefined) this.model.doc.cuerpo.cs_id_237 = "0";
    if (this.model.doc.cuerpo.cs_id_238 == undefined) this.model.doc.cuerpo.cs_id_238 = "0";
    if (this.model.doc.cuerpo.cs_id_239 == undefined) this.model.doc.cuerpo.cs_id_239 = "0";
    if (this.model.doc.cuerpo.cs_id_240 == undefined) this.model.doc.cuerpo.cs_id_240 = "0";
    if (this.model.doc.cuerpo.cs_id_241 == undefined) this.model.doc.cuerpo.cs_id_241 = "0";
    if (this.model.doc.cuerpo.cs_id_242 == undefined) this.model.doc.cuerpo.cs_id_241 = "0";
    if (this.model.doc.cuerpo.cs_id_243 == undefined) this.model.doc.cuerpo.cs_id_243 = "0";
    if (this.model.doc.cuerpo.cs_id_244 == undefined) this.model.doc.cuerpo.cs_id_244 = "0";
    if (this.model.doc.cuerpo.cs_id_245 == undefined) this.model.doc.cuerpo.cs_id_245 = "0";
    if (this.model.doc.cuerpo.cs_id_246 == undefined) this.model.doc.cuerpo.cs_id_246 = "0";
    if (this.model.doc.cuerpo.cs_id_247 == undefined) this.model.doc.cuerpo.cs_id_247 = "0";
    if (this.model.doc.cuerpo.cs_id_248 == undefined) this.model.doc.cuerpo.cs_id_248 = "0";
    if (this.model.doc.cuerpo.cs_id_249 == undefined) this.model.doc.cuerpo.cs_id_249 = "0";
    if (this.model.doc.cuerpo.cs_id_250 == undefined) this.model.doc.cuerpo.cs_id_250 = "0";
    if (this.model.doc.cuerpo.cs_id_251 == undefined) this.model.doc.cuerpo.cs_id_251 = "0";
    if (this.model.doc.cuerpo.cs_id_252 == undefined) this.model.doc.cuerpo.cs_id_252 = "0";
    if (this.model.doc.cuerpo.cs_id_253 == undefined) this.model.doc.cuerpo.cs_id_253 = "0";
    if (this.model.doc.cuerpo.cs_id_254 == undefined) this.model.doc.cuerpo.cs_id_254 = "0";
    if (this.model.doc.cuerpo.cs_id_255 == undefined) this.model.doc.cuerpo.cs_id_255 = "0";
    if (this.model.doc.cuerpo.cs_id_257 == undefined) this.model.doc.cuerpo.cs_id_257 = "0";
    if (this.model.doc.cuerpo.cs_id_267 == undefined) this.model.doc.cuerpo.cs_id_267 = "0";
    if (this.model.doc.cuerpo.cs_id_274 == undefined) this.model.doc.cuerpo.cs_id_274 = "0";
    if (this.model.doc.cuerpo.cs_id_258 == undefined) this.model.doc.cuerpo.cs_id_258 = "0";
    if (this.model.doc.cuerpo.cs_id_259 == undefined) this.model.doc.cuerpo.cs_id_259 = "0";
    if (this.model.doc.cuerpo.cs_id_260 == undefined) this.model.doc.cuerpo.cs_id_260 = "0";
    if (this.model.doc.cuerpo.cs_id_261 == undefined) this.model.doc.cuerpo.cs_id_261 = "0";
    if (this.model.doc.cuerpo.cs_id_262 == undefined) this.model.doc.cuerpo.cs_id_262 = null;
    if (this.model.doc.cuerpo.cs_id_263 == undefined) this.model.doc.cuerpo.cs_id_263 = "0";
    if (this.model.doc.cuerpo.cs_id_264 == undefined) this.model.doc.cuerpo.cs_id_264 = "0";
    if (this.model.doc.cuerpo.cs_id_265 == undefined) this.model.doc.cuerpo.cs_id_265 = "0";
    if (this.model.doc.cuerpo.cs_id_266 == undefined) this.model.doc.cuerpo.cs_id_266 = "0";
    if (this.model.doc.cuerpo.cs_id_268 == undefined) this.model.doc.cuerpo.cs_id_268 = "0";
    if (this.model.doc.cuerpo.cs_id_269 == undefined) this.model.doc.cuerpo.cs_id_269 = "0";
    if (this.model.doc.cuerpo.cs_id_473 == undefined) this.model.doc.cuerpo.cs_id_473 = "0";
    if (this.model.doc.cuerpo.cs_id_267 == undefined) this.model.doc.cuerpo.cs_id_267 = "0";
    if (this.model.doc.cuerpo.cs_id_268 == undefined) this.model.doc.cuerpo.cs_id_268 = "0";
    if (this.model.doc.cuerpo.cs_id_270 == undefined) this.model.doc.cuerpo.cs_id_270 = "0";
    if (this.model.doc.cuerpo.cs_id_271 == undefined) this.model.doc.cuerpo.cs_id_271 = "0";
    if (this.model.doc.cuerpo.cs_id_272 == undefined) this.model.doc.cuerpo.cs_id_272 = "0";
    if (this.model.doc.cuerpo.cs_id_273 == undefined) this.model.doc.cuerpo.cs_id_273 = "0";
    if (this.model.doc.cuerpo.cs_id_960 == undefined) this.model.doc.cuerpo.cs_id_960 = "0";
  }


  //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
    switch (this.indexStepper) {
      case 1:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_234 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_234 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_234 = val;
        }

        //Si ha seleccionado respuesta SI/NO en p12NecesitaActualizarBienes habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      
      case 21:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_262 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_262 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_262 = val;
        }

        //Si ha seleccionado respuesta SI/NO en p12NecesitaActualizarBienes habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      
    }
    console.log(this.model);
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 1:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_235, "0")){
          hasValues=true;
        }
        break;
      case 21:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_264, "0")){
          hasValues=true;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_265, "0")){
          hasValues=true;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_266, "0")){
          hasValues=true;
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_473, "0")){
          hasValues=true;
        }
        break;
    }
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 1:
        this.model.doc.cuerpo.cs_id_235="0";
        break;
      case 21:
        this.model.doc.cuerpo.cs_id_264="0";
        this.model.doc.cuerpo.cs_id_265="0";
        this.model.doc.cuerpo.cs_id_266="0";
        this.model.doc.cuerpo.cs_id_473="0";
        break;
      default:
        break;
    }
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    //Si no ha respondido  no puede saltar preguntas
    if( (indexS>=2 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_234==undefined || this.model.doc.cuerpo.cs_id_234=="")) ){
      habilitado = false;
    }
    //Si responde 'NO'  debe saltar preguntas del indexStepper
    else if( (indexS==2 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_234=="0")) ){
      habilitado = false;
    }
    //Si no ha respondido  no puede saltar preguntas
    if( (indexS>=22 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_262==undefined || this.model.doc.cuerpo.cs_id_262=="")) ){
      habilitado = false;
    }
    //Si responde 'NO'  debe saltar preguntas del indexStepper
    else if( (indexS==22 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_262=="0")) ){
      habilitado = false;
    }
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
    //Si no se ha seleccionado respuesta SI/NO en p12NecesitaActualizarBienes deshabilitar botón next
    switch(this.indexStepper){
      case 1:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_234==undefined || this.model.doc.cuerpo.cs_id_234=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 21:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_262==undefined || this.model.doc.cuerpo.cs_id_262=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      default:
        this.buttonRight.nativeElement.disabled = false;
        break;
    }
  }
  


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 232: this.operacionCs232(); break;
      case 257: this.operacionCs257(); break;
      case 234: this.operacionCs234(); break;
      case 235: this.operacionCs235(); break;
      case 236: this.operacionCs236(); break;
      case 237: this.operacionCs237(); break;
      case 238: this.operacionCs238(); break;
      case 239: this.operacionCs239(); break;
      case 240: this.operacionCs240(); break;
      case 241: this.operacionCs241(); break;
      case 242: this.operacionCs242(); break;
      case 243: this.operacionCs243(); break;
      case 244: this.operacionCs244(); break;
      case 245: this.operacionCs245(); break;
      case 246: this.operacionCs246(); break;
      case 247: this.operacionCs247(); break;
      case 248: this.operacionCs248(); break; 
      case 249: this.operacionCs249(); break;
      case 250: this.operacionCs250(); break;
      case 251: this.operacionCs251(); break;
      case 252: this.operacionCs252(); break;
      case 253: this.operacionCs253(); break;
      case 254: this.operacionCs254(); break;
      case 255: this.operacionCs255(); break;
      case 267: this.operacionCs267(); break;
      case 274: this.operacionCs274(); break;
      case 258: this.operacionCs258(); break;
      case 259: this.operacionCs259(); break;
      case 260: this.operacionCs260(); break;
      case 261: this.operacionCs261(); break;
      case 262: this.operacionCs262(); break;
      case 263: this.operacionCs263(); break;
      case 268: this.operacionCs268(); break;
      case 270: this.operacionCs270(); break;
      case 269: this.operacionCs269(); break;
      case 271: this.operacionCs271(); break;
      case 272: this.operacionCs272(); break;
      case 273: this.operacionCs273(); break;
      case 275: this.operacionCs275(); break;
      case 312: this.operacionCs312(); break;
      case 960: this.operacionCs960(); break; 
      case 473: this.operacionCs473(); break; 
      case 266: this.operacionCs266(); break; 
      case 265: this.operacionCs265(); break; 
      case 264: this.operacionCs264(); break; 


     
   }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }

  //ingresos 
operacionCs232() {
	const cas232 = this.model.doc.cuerpo.cs_id_232
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas232,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los ingresos no pueden ser cero");
      return;
   }
 }
 
 //número de meses
 operacionCs257() {
	const cas257 = this.model.doc.cuerpo.cs_id_257
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas257,"0")) {
	  // this.dNotificacionServicio.mostrarDialogoInformacion("Debe especificar el número de meses a los cuales corresponde el ingreso");
      return;
   }
  }
 
 //retiro ahorros de cuentas AFC
 operacionCs234(){
	const cas234 = this.model.doc.cuerpo.cs_id_234;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas234,"0")) {
		this.model.doc.cuerpo.cs_id_235="0";
	}
}

//valor retirado cuentas AFC..
operacionCs235() {
	const cas235 = this.model.doc.cuerpo.cs_id_235
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas235,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los retiros no pueden ser cero");
      this.model.doc.cuerpo.cs_id_235="0"
      return
   }
 }

//aportes a salud
operacionCs236() {
	//no tiene validaciones
}

//aportes a pension
operacionCs237() {
	//no tiene validaciones
}

//cotizacion voluntaria RAIS
operacionCs238() {
	this.operacionCs239();
}


//Limitante cotizacion voluntaria RAIS
operacionCs239() {
	//Valor se calcula en recalculo casillas 210
}

//Apoyos economicos a funcionarios
operacionCs240() {
	//no tiene validaciones
}

//aportes voluntarios cuentas AFC...
operacionCs241() {
	//no tiene validaciones
	this.operacionCs242();
}

//Limitante aportes voluntarios...
operacionCs242() {
  //Valor se calcula en recalculo casillas 210
}

//cesantias año 2016
operacionCs243(){
	const cas243 = this.model.doc.cuerpo.cs_id_243;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas243,"0")) {
		this.model.doc.cuerpo.cs_id_244="0";
		this.model.doc.cuerpo.cs_id_245="0";
	}
   this.operacionCs245();	
}

//salario promedio cesantias año 2016
operacionCs244() {
	const cas243 = this.model.doc.cuerpo.cs_id_243;
	const cas244 = this.model.doc.cuerpo.cs_id_244;
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas243,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas244,"0")) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El promedio de su salario no pueden ser mayor que cero ya que no reportó retiro de cesantias");
			this.model.doc.cuerpo.cs_id_244="0";
			return;
	   }
   } else {

	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas244,"0")) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El promedio de su salario debe ser mayor que cero ya que reportó retiro de cesantias");
			this.model.doc.cuerpo.cs_id_244="0";
			return;
	   }	   
	   
   }
   this.operacionCs245();
   
 }

//valor exento cesantias 2016 
operacionCs245() {
	const cas243 = this.model.doc.cuerpo.cs_id_243;
	const cas244 = this.model.doc.cuerpo.cs_id_244;
	this.model.doc.cuerpo.cs_id_245 =this.ObtenerCesantiaExenta(cas243,cas244);
}
 
 
//servicio para obtener valor exento de cesantias 
ObtenerCesantiaExenta(cesantia,salarioPromedio) {

	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cesantia,"0") || 
  this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,salarioPromedio,"0")) {
		return "0";
	}	
	
	//Convertir valor en uvt. Implementarla
	//let salarioUvt = this.convertirPesosUvt(salarioPromedio);
  let salarioUvt = salarioPromedio;
	
	const uvt350 = "13301400";
	const uvt410 = "15581640";
	const uvt470 = "17861880";
	const uvt530 = "20142120";
	const uvt590 = "22422360";	
	const uvt650 = "24702600";	
	
	let porExento;
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,salarioUvt,uvt350)) {
		porExento = "1";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,salarioUvt,uvt410)) {
		porExento = "0.9";		
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,salarioUvt,uvt470)) {
		porExento = "0.8";	
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,salarioUvt,uvt530)) {
		porExento = "0.6";	
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,salarioUvt,uvt590)) {
		porExento = "0.4";	
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,salarioUvt,uvt650)) {
		porExento = "0.2";	
    } else {
 		porExento = "0";	
	}	

	const resultado =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cesantia,porExento);
	
	return this.dutilidades.redondearValorMoneda(resultado,true);
	
}

//cesantias consignadas o pagadas
operacionCs246(){
	const cas246 = this.model.doc.cuerpo.cs_id_246;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas246,"0")) {
		this.model.doc.cuerpo.cs_id_247="0";
		this.model.doc.cuerpo.cs_id_248="0";
	}
   this.operacionCs248();	
}

//salario promedio para cesantias consignadas o pagadas
operacionCs247() {
	const cas246 = this.model.doc.cuerpo.cs_id_246;
	const cas247 = this.model.doc.cuerpo.cs_id_247;
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas246,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas247,"0")) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El promedio de su salario no pueden ser mayor que cero ya que no reportó consignación/pagos de cesantias");
			this.model.doc.cuerpo.cs_id_247="0";
			return;
	   }
   } else {

	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas247,"0")) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El promedio de su salario debe ser mayor que cero ya que reportó consignación/pagos de cesantias");
			this.model.doc.cuerpo.cs_id_247="0";
			return;
	   }	   
	   
   }
   this.operacionCs248();
   
 }

//valor exento de cesantias consignadas o pagadas
operacionCs248() {
	const cas246 = this.model.doc.cuerpo.cs_id_246;
	const cas247 = this.model.doc.cuerpo.cs_id_247;
	this.model.doc.cuerpo.cs_id_248 =this.ObtenerCesantiaExenta(cas246,cas247);
}

//gastos representacion fiscal/procurador 
operacionCs960() {
	const cas960 = this.model.doc.cuerpo.cs_id_960;
	const cas232 = this.model.doc.cuerpo.cs_id_232;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas960,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas960,cas232)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_960="0";
	   }		
	}
}

//gastos representacion fiscal/procurador 
operacionCs249() {
	const cas249 = this.model.doc.cuerpo.cs_id_249;
	const cas232 = this.model.doc.cuerpo.cs_id_232;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas249,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas249,cas232)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_249="0";
	   }		
	}
}

//gastos representacion juez
operacionCs250() {
	const cas250 = this.model.doc.cuerpo.cs_id_250;
	const cas232 = this.model.doc.cuerpo.cs_id_232;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas250,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas250,cas232)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_250="0";
	   }		
	}
}

//indemnizaciones ARL,maternidad
operacionCs251() {
	//no tiene validaciones
}

//prestaciones solicitas FF.MM/Policia
operacionCs252() {
	const cas252 = this.model.doc.cuerpo.cs_id_252;
	const cas232 = this.model.doc.cuerpo.cs_id_232;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas252,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas252,cas232)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_252="0";
	   }		
	}
}

//salario adiciona FF.MM/Policia
operacionCs253() {
	const cas253 = this.model.doc.cuerpo.cs_id_253;
	const cas232 = this.model.doc.cuerpo.cs_id_232;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas253,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas253,cas232)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_253="0";
	   }		
	}
}

//indemnizacion muerte familiar FF.MM/Policia
operacionCs254() {
	//no tiene validaciones
}

//ingresos CAN
operacionCs255() {
	const cas255 = this.model.doc.cuerpo.cs_id_255;
	const cas232 = this.model.doc.cuerpo.cs_id_232;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas255,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas255,cas232)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_255="0";
	   }		
	}
}

//prima funcionario ministerio de relaciones exteriores
operacionCs267() {
	const cas267 = this.model.doc.cuerpo.cs_id_267;
	const cas232 = this.model.doc.cuerpo.cs_id_232;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas267,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas267,cas232)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_267="0";
	   }		
	}
}

//indemnizacion por retiro entidades publicas
operacionCs274() {
	//no tiene validaciones
}

//intereses prestamos de vivienda
operacionCs258(){
	const cas258 = this.model.doc.cuerpo.cs_id_258;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas258,"0")) {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas291 = this.model.doc.cuerpo.cs_id_291;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas291,"0")) {
			this.model.doc.cuerpo.cs_id_258="0";
			this.model.doc.cuerpo.cs_id_259="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
			return
		}
		
		const cas325 = this.model.doc.cuerpo.cs_id_325;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas325,"0")) {
			this.model.doc.cuerpo.cs_id_258="0";
			this.model.doc.cuerpo.cs_id_259="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
			return
		}
		
		const cas412 = this.model.doc.cuerpo.cs_id_412;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas412,"0")) {
			this.model.doc.cuerpo.cs_id_258="0";
			this.model.doc.cuerpo.cs_id_259="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		
		const cas519 = this.model.doc.cuerpo.cs_id_519;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas519,"0")) {
			this.model.doc.cuerpo.cs_id_258="0";
			this.model.doc.cuerpo.cs_id_259="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
			return
		}
	}
	
	this.operacionCs259();
}

//limitante intereses prestamos de vivienda
operacionCs259(){
	const cas258 = this.model.doc.cuerpo.cs_id_258;
	const uvt1200 = "45605000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas258,uvt1200)) {
		this.model.doc.cuerpo.cs_id_259 = cas258;
	} else {
		this.model.doc.cuerpo.cs_id_259 = uvt1200;
	}
}

//intereses icetex
operacionCs260(){
	const cas260 = this.model.doc.cuerpo.cs_id_260;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas260,"0")) {
		
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas286 = this.model.doc.cuerpo.cs_id_286;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas286,"0")) {
			this.model.doc.cuerpo.cs_id_260="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente');
			return;
		}
		
		const cas327 = this.model.doc.cuerpo.cs_id_327;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas327,"0")) {
			this.model.doc.cuerpo.cs_id_260="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas por honorarios');
			return;
		}
		
		const cas414 = this.model.doc.cuerpo.cs_id_414;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas414,"0")) {
			this.model.doc.cuerpo.cs_id_260="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas de capital');
			return;
		}
		
		const cas521 = this.model.doc.cuerpo.cs_id_521;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas521,"0")) {
			this.model.doc.cuerpo.cs_id_260="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas no laborales');
			return;
		}
	}
	
	this.operacionCs261();
}

//limitante intereses icetex
operacionCs261(){
	const cas260 = this.model.doc.cuerpo.cs_id_260;
	const uvt100 = "3800000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas260,uvt100)) {
		this.model.doc.cuerpo.cs_id_261 = cas260;
	} else {
		this.model.doc.cuerpo.cs_id_261 = uvt100;
	}
}

//Tuvo dependiente economico?
operacionCs262(){
	const cas262 = this.model.doc.cuerpo.cs_id_262;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas262,"0")) {
		this.model.doc.cuerpo.cs_id_264="0";
		this.model.doc.cuerpo.cs_id_265="0";
		this.model.doc.cuerpo.cs_id_266="0";
		this.model.doc.cuerpo.cs_id_473="0";
		this.model.doc.cuerpo.cs_id_263="0";
	}
}


//validar diligenciamiento datos del dependiente economico
//debe ejecutarse antes de cambiar de tarjeta. garantizar que los valores fueron seleccionados. Pasar a la siguiente tarjeta solo si estan dilgienciandos los datos

operacionCs264()
{		
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_264,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el tipo de documento del dependiente económico');
			return;
}	
}		

operacionCs265()
{	
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_265,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el número de documento del dependiente económico');
			return;
	    }	
  }
operacionCs266()
 {	
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_266,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el parentesco con el dependiente económico');
			return;
	    }	
  }
operacionCs473()
{	
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_473,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el número de meses del año que tuvo la calidad de dependiente económico');
			return;
	    }			

}


//limitante dependiente economico
operacionCs263() {
	//el valor del limitante se calcula en el 210
}

//medicina prepagada
operacionCs268(){
	
	const cas268 = this.model.doc.cuerpo.cs_id_268;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas268,"0")) {
		this.model.doc.cuerpo.cs_id_269="0";
		this.model.doc.cuerpo.cs_id_270="0";
	} else {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas300 = this.model.doc.cuerpo.cs_id_300;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas300,"0")) {
			this.model.doc.cuerpo.cs_id_269="0";
			this.model.doc.cuerpo.cs_id_270="0";
			this.model.doc.cuerpo.cs_id_268="0";
			this.dNotificacionServicio.
      mostrarDialogoInformacion('El valor de medicina prepagada ya está diligenciado en las rentas de trabajo como trabajador independiente');
			return;
		}
		
		const cas334 = this.model.doc.cuerpo.cs_id_334;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas334,"0")) {
			this.model.doc.cuerpo.cs_id_269="0";
			this.model.doc.cuerpo.cs_id_270="0";
			this.model.doc.cuerpo.cs_id_268="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('El valor de medicina prepagada ya está diligenciado en las rentas por honorarios');
			return;
		}
		this.operacionCs269();	
	}
}

//número de meses medicina prepagada
operacionCs270() {
   this.operacionCs269();		
}

//limitante medicina prepagada
operacionCs269(){
	
	const cas268 = this.model.doc.cuerpo.cs_id_268;
	const cas270 = this.model.doc.cuerpo.cs_id_270;
	
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas268,"0") 
  || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas270,"0")) {
		this.model.doc.cuerpo.cs_id_269=0;
		return 
	}
	
	const valorTope = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,cas268,cas270);
	
	let cas269 = "0";
	let uvt16 = "608064";
	let uvt192 = "7296768";
  if(this.UVT != '')
  {
    uvt16=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.UVT,'16');
    uvt192=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.UVT,'192');
  }
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,valorTope,uvt16)) {
		cas269 =  this.dutilidades.redondearValorMoneda(cas268,true);
	} else {
		cas269 = this.dutilidades.redondearValorMoneda(uvt192,true); ;
	}
	this.model.doc.cuerpo.cs_id_269 = cas269;
}

//donacion para investigacion
operacionCs271(){
	
	const cas271 = this.model.doc.cuerpo.cs_id_271;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas271,"0")) {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas303 = this.model.doc.cuerpo.cs_id_303;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas303,"0")) {
			this.model.doc.cuerpo.cs_id_271="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente');
			return;
		}
		
		const cas337 = this.model.doc.cuerpo.cs_id_337;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas337,"0")) {
			this.model.doc.cuerpo.cs_id_271="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas por honorarios');
			return;
		}
		
		const cas416 = this.model.doc.cuerpo.cs_id_416;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas416,"0")) {
			this.model.doc.cuerpo.cs_id_271="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas de capital');
			return;
		}
		
		const cas523 = this.model.doc.cuerpo.cs_id_523;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas523,"0")) {
			this.model.doc.cuerpo.cs_id_271="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('Ya reportó por esta deducción en las rentas no laborales');
			return;
		}
	}
}

//4 x mil
operacionCs272(){
	this.operacionCs273();
}


//limitante 4 x mil
operacionCs273(){
	const porcentajeTopeMax = "0.50";
	const cas272 = this.model.doc.cuerpo.cs_id_272;
	const resultado =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas272,porcentajeTopeMax);
	this.model.doc.cuerpo.cs_id_273 = this.dutilidades.redondearValorMoneda(resultado ,true);
}


//es trabajador independiente por prestacion de servicios
operacionCs275(){
	const cas275 = this.model.doc.cuerpo.cs_id_275;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas275,"0")) {
		this.model.doc.cuerpo.cs_id_277="0";
		this.model.doc.cuerpo.cs_id_278=null;	
		this.model.doc.cuerpo.cs_id_264=0;	
	}
}


//es trabajador independiente por actividades técnicas
operacionCs312(){
	const cas312 = this.model.doc.cuerpo.cs_id_312;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas312,"0")) {
		this.model.doc.cuerpo.cs_id_314="0";
		this.model.doc.cuerpo.cs_id_315=null;	
		this.model.doc.cuerpo.cs_id_672=0;	
	}
}

//UVT 
private obtenerValorPeriodico110(): void {
  this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION).subscribe(
    data => this.setObjectFromResponse(data),
    error => console.log(error)
  )
}
private setObjectFromResponse(data: any): void {
  
      let model=<DValorPeriodico>data;
      this.UVT = String(model.valor);
   
}
private convertirPesosUvt(valorPesos) {
  valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
  let valorOperacion = new BigNumber210(valorPesos);
  valorOperacion = valorOperacion.div(this.UVT);
  valorOperacion = valorOperacion.toFormat();
  const punto = valorOperacion.indexOf(".") + 1;
  if ((punto > 0) && (valorOperacion.length - punto) > 2)
    valorOperacion = valorOperacion.slice(0, -1);
  return String(valorOperacion);
}


}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-laboral/renta-laboral-asalariado/renta-laboral-asalariado-modal.component.ts